import React from "react";
import MobileRoadmapView from "./MobileRoadmapView";
import useStartupStore from "../../stores/startupStore";
import styled from "styled-components";
import SVGSliderLoader from "../../stories/SVGSliderLoader";
import { LoadingOverlay } from "@mantine/core";

const MobileContainer = styled.div`
  background-color: #f8f9fa;
  min-height: 100vh;
  position: relative;
  padding-inline: 8px;
`;

const MobileProjectContainer = () => {
  const { program } = useStartupStore((state) => ({
    program: state.program,
  }));
  
  if (!program || program.loading) {
    return (
      <MobileContainer>
        <div style={{ minHeight: "100vh", position: "relative" }}>
          <LoadingOverlay visible={true} loader={<SVGSliderLoader />} />
        </div>
      </MobileContainer>
    );
  }

  return (
    <MobileContainer>
      <MobileRoadmapView />
    </MobileContainer>
  );
};

export default MobileProjectContainer;
